import { LanguageNameSpaces } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";
import { useTranslation } from "react-i18next";
import { useBranding } from "@shared/utils/hooks/useBranding";

const useTypedTranslation = <NS extends LanguageNameSpaces>(ns: NS) => {
  const { t, i18n } = useTranslation(ns);
  const { isWhitelabel } = useBranding();

  const typedT = (key: TranslationKeys<NS>, options?: any) => {
    if (isWhitelabel) {
      const whitelabelKey = `${key as string}_whitelabel`;
      if (i18n.exists(whitelabelKey, { ns })) {
        return t(whitelabelKey, options) as string;
      }
    }

    return t(key as string, options) as string;
  };

  return { t: typedT, i18n };
};

export default useTypedTranslation;
